// bust.$emit('animateBottombar')
import _ from "lodash";

export default {
  state: {
    // isAnimating: false,

    animationOrder: ["BackgroundTransition", "Background", "BottomBar", "SubBottomBar", "Slides", "ReferenceSlider", "SideBar", "BackgroundVideo", "Tags", "LivingOptionTags", "LivingOptionSubsections", "LivingOptionProperties"],
    newAnimationQueue: [],
  },
  getters: {
    sortedAnimationQueue(state) {
      let sorted = [];
      state.animationOrder.forEach((component) => {
        if (state.newAnimationQueue.includes(component)) {
          sorted.push(component);
        }
      });
      return sorted;
    },
  },

  mutations: {
    addAnimationToQueue(state, component) {
      if (state.newAnimationQueue.indexOf(component) !== -1) return;
      let queue = state.newAnimationQueue;
      queue.push(component);
      state.newAnimationQueue = _.uniq(queue);
    },

    advanceAnimationQueue(state, lastAnimatedComponent) {
      // console.log(lastAnimatedComponent);
      let componentIndex = state.newAnimationQueue.indexOf(lastAnimatedComponent);
      state.newAnimationQueue = state.newAnimationQueue.toSpliced(componentIndex, 1);
    },

    clearAnimationQueue(state) {
      state.newAnimationQueue = [];
    },
  },
};
